import { QueryClient, QueryCache, MutationCache } from "@tanstack/react-query";
import localforage from "localforage";

// 1️⃣ Create the QueryClient
export const queryClient = new QueryClient({
  queryCache: new QueryCache(),
  mutationCache: new MutationCache(),
  defaultOptions: {
    queries: {
      staleTime: 10 * 60 * 1000, // 10 minutes
      gcTime: 24 * 60 * 60 * 1000, // 24 hours (formerly cacheTime)
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

// 2️⃣ Create an IndexedDB persister using localforage
export const localStoragePersister = {
  persistClient: async (client) => {
    await localforage.setItem("react-query", client);
  },
  restoreClient: async () => {
    return await localforage.getItem("react-query");
  },
  removeClient: async () => {
    await localforage.removeItem("react-query");
  },
};

// 3️⃣ Persist the QueryClient
// Removed direct call to persistQueryClient as it will be handled by PersistQueryClientProvider
// in index.js for better component lifecycle integration.
